import type { ComponentType, SVGProps } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ChevronRight } from "lucide-react";
import { ItemIcon, type ItemIconKey } from "@/shared/ui/core";

/**
 * La cabecera de las cards del resumen, como en la referencia: el icono
 * en una burbuja lavanda, el título en mayúsculas espaciadas y, a la
 * derecha, "Ver ›" hacia la sección.
 */
export function CardHeader({
  icon: Icon,
  item,
  title,
  to,
  toLabel,
}: {
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  /** El item 3D de la marca; cuando viene, sustituye a la burbuja con `icon`. */
  item?: ItemIconKey;
  title: string;
  to?: string;
  toLabel?: string;
}) {
  const { t } = useTranslation();
  return (
    <div className="flex items-center justify-between gap-3">
      <div className="flex min-w-0 items-center gap-3">
        {item ? (
          <ItemIcon item={item} size={40} />
        ) : (
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-ds-lavender-bg text-ds-violet-pop">
            <Icon className="h-4 w-4" />
          </span>
        )}
        <h2 className="truncate text-[12px] font-bold uppercase tracking-[0.14em] text-ds-ink">
          {title}
        </h2>
      </div>
      {to && (
        <Link
          to={to}
          className="inline-flex shrink-0 items-center gap-0.5 text-[13px] font-medium text-ds-violet-pop hover:underline"
        >
          {toLabel ?? t("Ver")}
          <ChevronRight className="h-4 w-4" />
        </Link>
      )}
    </div>
  );
}
